<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <GoodsInfo
          :disabled="disabled"
          :evgSpuCode="evgSpuCode"
          :evgSkuCode="evgSkuCode"
          @updateIsSpuCopy="updateIsSpuCopy"
          :isCopy="isCopy"
          v-if="visible"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import GoodsInfo from '@/views/ecom/base/evgGoods/components/evg-good-info'
export default {
  components: { GoodsInfo },
  props: {
    visible: { type: Boolean, default: false },
    optType: { type: String, default: '' },
    evgSpuCode: { type: String, default: '' },
    evgSkuCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('dialog_title_edit_SKU') || '编辑SKU',
        add: this.$l('dialog_title_Add_SKU') || '新增SKU',
        copy: this.$l('dialog_title_Add_SKU') || '新增SKU',
        detail: this.$l('dialog_title_SKU_detail') || 'SKU详情',
      },
      isCopy: false,
    }
  },
  created() {
    this.isCopy = this.optType === 'copy'
  },
  watch: {
    optType: {
      handler() {
        this.isCopy = this.optType === 'copy'
      },
      immediate: true,
    },
  },
  computed: {
    title() {
      return this.titleMap[this.optType]
    },
    disabled() {
      return this.optType === 'detail'
    },
  },
  methods: {
    updateIsSpuCopy(e) {
      this.isCopy = e
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleClose(done) {
      if (this.disabled) return done()
      this.$confirm(
        this.$l('tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('btn_check_confirm') || '确定',
          cancelButtonText:
            this.$l('btn_check_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => done())
        .catch(() => {})
    },
  },
}
</script>
